export const RANK_COLOR: Record<number, string> = {
  [1]: '#F61616',
  [2]: '#FF6518',
  [3]: '#FFB222',
}
export const OTHER_RANK_COLOR = '#16ABF6'
